import React from 'react'
import classNames from 'classnames'

/**
 * ? So what the hell is happening here?
 *
 * In some occurences the cursor would be totally lost in this textarea component
 * Because of full re-renders between two value changes in the case of it being a
 * controlled component. One occurence of this issue appears in the TargetForm component.
 *
 * I tried a few things and this one seems to be the "simplest", best working one.
 * See this issue for more details: https://github.com/facebook/react/issues/955
 */
export default class Textarea extends React.Component {
  selection = {
    start: null,
    end: null,
  }

  static defaultProps = {
    onChange: () => {},
  }

  constructor(props) {
    super(props)
    this.textareaRef = React.createRef()
  }

  componentDidUpdate() {
    const { selectionStart, selectionEnd } = this.textareaRef.current
    const update =
      (this.selection.start !== false &&
        this.selection.start !== selectionStart) ||
      (this.selection.end !== false && this.selection.end !== selectionEnd)

    if (update) {
      this.textareaRef.current.selectionStart = this.selection.start
      this.textareaRef.current.selectionEnd = this.selection.end
    }
  }

  handleChange = event => {
    const input = this.textareaRef.current
    this.selection = {
      start: input.selectionStart,
      end: input.selectionEnd,
    }

    this.props.onChange(event)
  }

  render() {
    const { className, group, size, resize, height, ...props } = this.props

    return (
      <textarea
        ref={this.textareaRef}
        style={{
          minHeight: 140,
          resize: resize || 'vertical',
          height: height || null,
        }}
        className={classNames(
          [
            'width-full padding-large',
            'border-small border-shade-30 border-shade-20-on-focus radius-normal',
            'font-size-normal',
          ],
          className
        )}
        {...props}
        onChange={this.handleChange}
      />
    )
  }
}
